import React from "react";
import {css, Theme} from "@emotion/react";
import classNames from "classnames";

import {VoivodeshipType} from "../../vendor/helpers/VoivodeshipType";
import {MapOfPolandMarkers} from "./MapOfPolandMarkers";

interface IProps {
    className?: string;
    width?: number;
    height?: number;
    regions?: string[] | null;
}

export const MapOfPoland: React.FunctionComponent<IProps> = (props) => {
    const classNameRegion = classNames(props.regions?.map((region) => region));
    const className = classNames(classNameRegion);

    return (
        <svg width={props.width || "164"} height={props.height || "157"} className={className} css={mapOfPoland} viewBox="0 0 164 157">
            <path
                css={[mapContour]}
                d="M66.768,1.595L43.753,7.804l-3.478,0.663l-6.871,7.368 L3.518,24.03L4.43,46.3l-3.146,2.814l0.744,4.305l6.043,6.042l-1.406,6.21l1.738,10.266l-1.821,3.808l1.821,7.947l2.98,2.814 l-0.496,3.479l-2.07,11.092l3.56-0.164l2.98-2.318l12.005,8.359l7.284,1.74l-3.063,6.043l8.113,8.859l5.05-4.635l-0.58-5.879 l1.904,1.57l5.216,4.057l6.954-0.246l-2.566,3.229l1.904,2.732l4.057,1.158l8.858,1.986l7.7,13.123l5.648-4.145l2.463-1.277 l8.362,11.508l13.163-7.039l5.05,3.313l7.203-1.408l7.946-1.158l15.731,7.947l-1.822-13l13.577-21.107l2.069-2.734l4.801-1.738 l0.332-10.098l-8.444-22.686l0.744-7.947l-7.533-4.883l-1.571-1.656l9.852-10.929l0.33-13.08l-10.598-27.568l-8.526-3.311 l-50.17-0.746l-4.719,2.153l-7.532,2.069l-5.134-9.521l5.217,2.98l0.662-1.076L66.768,1.595L66.768,1.595z"
            />

            {/* Dolnoslaskie */}
            <polygon
                className={`regions ${VoivodeshipType.DOLNOSLASKIE}`}
                points="31.862,118.479 34.993,112.298 27.393,110.485 15.307,102.048 12.241,104.432 9.073,104.58 11.061,93.927 13.077,93.229 27.786,82.255 34.53,84.918 36.591,82.664 46.35,88.533 53.871,86.981 58.027,96.733 52.485,101.379 45.958,118.024 43.849,116.283 44.478,122.646 39.697,127.034"
            />

            {/* Kujawskopomorskie */}
            <polygon
                className={`regions ${VoivodeshipType.KUJAWSKOPOMORSKIE}`}
                points="57.187,58.065 54.33,51.863 52.795,37.277 65.888,30.528 81.343,36.498 83.177,41.249 88.695,42.252 92.35,46.702 84.099,64.591 78.739,65.551"
            />

            {/* Lodzkie */}
            <polygon
                className={`regions ${VoivodeshipType.LODZKIE}`}
                points="79.931,100.45 72.393,100.532 65.344,97.07 78.444,70.852 78.947,66.022 84.225,65.077 99.403,74.026 104.223,83.563 100.858,93.408 92.058,105.939"
            />

            {/* Lubelskie */}
            <polygon
                className={`regions ${VoivodeshipType.LUBELSKIE}`}
                points="134.903,117.349 130.982,107.829 126.2,106.156 125.96,100.938 126.78,76.705 142.211,73.488 144.365,68.768 147.537,68.227 154.87,72.98 154.131,80.844 162.605,103.605 162.265,113.45 157.548,115.16 155.536,117.815 152.058,116.746 148.455,119.993"
            />

            {/* Lubuskie */}
            <polygon
                className={`regions ${VoivodeshipType.LUBUSKIE}`}
                points="11.604,90.165 8.581,87.31 6.794,79.513 8.614,75.708 6.861,65.353 8.242,59.34 30.506,46.63 27.233,73.553 37.647,80.769 34.393,84.326 27.71,81.687 12.846,92.793 11.146,93.37"
            />

            {/* Malopolskie */}
            <polygon
                className={`regions ${VoivodeshipType.MALOPOLSKIE}`}
                points="86.419,138.753 83.991,140.014 79.167,129.887 85.107,119.878 94.999,115.705 100.427,117.564 103.373,122.869 114.825,119.905 119.864,145.258 112.998,146.602 107.905,143.26 94.787,150.271"
            />

            {/* Mazowieckie */}
            <polygon
                className={`regions ${VoivodeshipType.MAZOWIECKIE}`}
                points="101.413,93.331 104.764,83.526 99.784,73.669 84.593,64.714 92.812,46.895 101.873,45.752 118.642,37.483 122.342,48.29 138.709,65.071 143.878,68.631 141.861,73.05 126.292,76.296 125.716,101.397"
            />

            {/* Opolskie */}
            <polygon
                className={`regions ${VoivodeshipType.OPOLSKIE}`}
                points="57.738,128.002 55.989,125.491 58.78,121.979 51.368,122.246 46.365,118.354 52.904,101.68 58.415,97.061 64.994,97.434 72.054,100.923 67.728,122.722 61.223,124.891 61.383,129.042"
            />

            {/* Podkarpackie */}
            <polygon
                className={`regions ${VoivodeshipType.PODKARPACKIE}`}
                points="128.157,144.037 120.357,145.174 115.287,119.664 126.04,106.631 130.605,108.228 134.544,117.788 148.604,120.532 152.183,117.307 155.241,118.247 141.775,139.181 143.547,151.813"
            />

            {/* Podlaskie */}
            <polygon
                className={`regions ${VoivodeshipType.PODLASKIE}`}
                points="139.029,64.691 122.779,48.021 119.094,37.26 136.861,28.481 133.771,17.034 137.167,11.666 145.408,14.866 155.977,42.361 155.632,55.267 145.675,66.311 147.087,67.797 144.25,68.28"
            />

            {/* Pomorskie */}
            <polygon
                className={`regions ${VoivodeshipType.POMORSKIE}`}
                points="46.061,32.602 45.234,9.291 44.141,7.614 66.737,1.519 74.984,7.284 74.571,7.955 68.801,4.656 74.449,15.131 81.96,13.069 87.224,27.566 81.442,36 65.858,29.981 52.544,36.844"
            />

            {/* Slaskie */}
            <polygon
                className={`regions ${VoivodeshipType.SLASKIE}`}
                points="70.674,131.147 61.888,129.175 61.736,125.246 68.162,123.104 72.542,101.031 79.826,100.952 91.938,106.435 94.685,115.295 84.762,119.481 78.601,129.861 83.563,140.275 78.296,144.135"
            />

            {/* Swietokrzyskie */}
            <polygon
                className={`regions ${VoivodeshipType.SWIETOKRZYSKIE}`}
                points="100.771,117.154 95.191,115.242 92.419,106.296 101.192,93.785 125.708,101.922 125.708,106.247 114.877,119.375 103.623,122.289"
            />

            {/* Warminskomazurskie */}
            <polygon
                className={`regions ${VoivodeshipType.WARMINSKOMAZURSKIE}`}
                points="88.965,41.793 83.542,40.808 81.817,36.337 87.782,27.638 82.43,12.898 86.892,10.862 136.616,11.601 133.232,16.952 136.271,28.214 101.731,45.28 92.748,46.399"
            />

            {/* Wielkopolskie */}
            <polygon
                className={`regions ${VoivodeshipType.WIELKOPOLSKIE}`}
                points="58.499,96.564 54.17,86.409 46.44,88.004 36.935,82.288 38.402,80.685 27.766,73.313 30.994,46.76 32.762,48.824 40.913,43.015 37.864,36.835 45.796,33.027 52.283,37.271 52.313,38.218 53.854,51.996 56.822,58.468 78.45,65.98 77.972,70.715 64.858,96.925"
            />

            {/* Zachodniopomorskie */}
            <polygon
                className={`regions ${VoivodeshipType.ZACHODNIOPOMORSKIE}`}
                points="2.206,53.009 1.497,48.913 4.63,46.108 3.722,23.895 33.517,15.723 40.39,8.355 43.625,7.739 44.739,9.447 45.56,32.585 37.192,36.603 40.276,42.854 32.844,48.151 30.87,45.847 8.065,58.866"
            />

            {props.regions && <MapOfPolandMarkers regions={props.regions} />}
        </svg>
    );
};

const mapContour = (theme: Theme) => css`
    fill: #fff;
    stroke: ${theme.colors.secondary};
    stroke-width: 1.5px;
`;

const mapOfPoland = (theme: Theme) => css`
    .regions {
        fill: #fff;
        stroke: ${theme.colors.secondary};
        stroke-width: 1px;
    }

    &.dolnoslaskie {
        .regions.dolnoslaskie {
            fill: ${theme.colors.gray["200"]};
        }
    }

    &.kujawsko-pomorskie {
        .regions.kujawsko-pomorskie {
            fill: ${theme.colors.gray["200"]};
        }
    }

    &.lodzkie {
        .regions.lodzkie {
            fill: ${theme.colors.gray["200"]};
        }
    }

    &.lubelskie {
        .regions.lubelskie {
            fill: ${theme.colors.gray["200"]};
        }
    }

    &.lubuskie {
        .regions.lubuskie {
            fill: ${theme.colors.gray["200"]};
        }
    }

    &.malopolskie {
        .regions.malopolskie {
            fill: ${theme.colors.gray["200"]};
        }
    }

    &.mazowieckie {
        .regions.mazowieckie {
            fill: ${theme.colors.gray["200"]};
        }
    }

    &.opolskie {
        .regions.opolskie {
            fill: ${theme.colors.gray["200"]};
        }
    }

    &.podkarpackie {
        .regions.podkarpackie {
            fill: ${theme.colors.gray["200"]};
        }
    }

    &.podlaskie {
        .regions.podlaskie {
            fill: ${theme.colors.gray["200"]};
        }
    }

    &.pomorskie {
        .regions.pomorskie {
            fill: ${theme.colors.gray["200"]};
        }
    }

    &.slaskie {
        .regions.slaskie {
            fill: ${theme.colors.gray["200"]};
        }
    }

    &.swietokrzyskie {
        .regions.swietokrzyskie {
            fill: ${theme.colors.gray["200"]};
        }
    }

    &.warminsko-mazurskie {
        .regions.warminsko-mazurskie {
            fill: ${theme.colors.gray["200"]};
        }
    }

    &.wielkopolskie {
        .regions.wielkopolskie {
            fill: ${theme.colors.gray["200"]};
        }
    }

    &.zachodniopomorskie {
        .regions.zachodniopomorskie {
            fill: ${theme.colors.gray["200"]};
        }
    }
`;
import React from "react";
import {css, Theme} from "@emotion/react";
import classNames from "classnames";

import {VoivodeshipType} from "../../vendor/helpers/VoivodeshipType";
import {MapOfPolandMarkers} from "./MapOfPolandMarkers";

interface IProps {
    className?: string;
    width?: number;
    height?: number;
    regions?: string[] | null;
}

export const MapOfPoland: React.FunctionComponent<IProps> = (props) => {
    const classNameRegion = classNames(props.regions?.map((region) => region));
    const className = classNames(classNameRegion);

    return (
        <svg width={props.width || "164"} height={props.height || "157"} className={className} css={mapOfPoland} viewBox="0 0 164 157">
            <path
                css={[mapContour]}
                d="M66.768,1.595L43.753,7.804l-3.478,0.663l-6.871,7.368 L3.518,24.03L4.43,46.3l-3.146,2.814l0.744,4.305l6.043,6.042l-1.406,6.21l1.738,10.266l-1.821,3.808l1.821,7.947l2.98,2.814 l-0.496,3.479l-2.07,11.092l3.56-0.164l2.98-2.318l12.005,8.359l7.284,1.74l-3.063,6.043l8.113,8.859l5.05-4.635l-0.58-5.879 l1.904,1.57l5.216,4.057l6.954-0.246l-2.566,3.229l1.904,2.732l4.057,1.158l8.858,1.986l7.7,13.123l5.648-4.145l2.463-1.277 l8.362,11.508l13.163-7.039l5.05,3.313l7.203-1.408l7.946-1.158l15.731,7.947l-1.822-13l13.577-21.107l2.069-2.734l4.801-1.738 l0.332-10.098l-8.444-22.686l0.744-7.947l-7.533-4.883l-1.571-1.656l9.852-10.929l0.33-13.08l-10.598-27.568l-8.526-3.311 l-50.17-0.746l-4.719,2.153l-7.532,2.069l-5.134-9.521l5.217,2.98l0.662-1.076L66.768,1.595L66.768,1.595z"
            />

            {/* Dolnoslaskie */}
            <polygon
                className={`regions ${VoivodeshipType.DOLNOSLASKIE}`}
                points="31.862,118.479 34.993,112.298 27.393,110.485 15.307,102.048 12.241,104.432 9.073,104.58 11.061,93.927 13.077,93.229 27.786,82.255 34.53,84.918 36.591,82.664 46.35,88.533 53.871,86.981 58.027,96.733 52.485,101.379 45.958,118.024 43.849,116.283 44.478,122.646 39.697,127.034"
            />

            {/* Kujawskopomorskie */}
            <polygon
                className={`regions ${VoivodeshipType.KUJAWSKOPOMORSKIE}`}
                points="57.187,58.065 54.33,51.863 52.795,37.277 65.888,30.528 81.343,36.498 83.177,41.249 88.695,42.252 92.35,46.702 84.099,64.591 78.739,65.551"
            />

            {/* Lodzkie */}
            <polygon
                className={`regions ${VoivodeshipType.LODZKIE}`}
                points="79.931,100.45 72.393,100.532 65.344,97.07 78.444,70.852 78.947,66.022 84.225,65.077 99.403,74.026 104.223,83.563 100.858,93.408 92.058,105.939"
            />

            {/* Lubelskie */}
            <polygon
                className={`regions ${VoivodeshipType.LUBELSKIE}`}
                points="134.903,117.349 130.982,107.829 126.2,106.156 125.96,100.938 126.78,76.705 142.211,73.488 144.365,68.768 147.537,68.227 154.87,72.98 154.131,80.844 162.605,103.605 162.265,113.45 157.548,115.16 155.536,117.815 152.058,116.746 148.455,119.993"
            />

            {/* Lubuskie */}
            <polygon
                className={`regions ${VoivodeshipType.LUBUSKIE}`}
                points="11.604,90.165 8.581,87.31 6.794,79.513 8.614,75.708 6.861,65.353 8.242,59.34 30.506,46.63 27.233,73.553 37.647,80.769 34.393,84.326 27.71,81.687 12.846,92.793 11.146,93.37"
            />

            {/* Malopolskie */}
            <polygon
                className={`regions ${VoivodeshipType.MALOPOLSKIE}`}
                points="86.419,138.753 83.991,140.014 79.167,129.887 85.107,119.878 94.999,115.705 100.427,117.564 103.373,122.869 114.825,119.905 119.864,145.258 112.998,146.602 107.905,143.26 94.787,150.271"
            />

            {/* Mazowieckie */}
            <polygon
                className={`regions ${VoivodeshipType.MAZOWIECKIE}`}
                points="101.413,93.331 104.764,83.526 99.784,73.669 84.593,64.714 92.812,46.895 101.873,45.752 118.642,37.483 122.342,48.29 138.709,65.071 143.878,68.631 141.861,73.05 126.292,76.296 125.716,101.397"
            />

            {/* Opolskie */}
            <polygon
                className={`regions ${VoivodeshipType.OPOLSKIE}`}
                points="57.738,128.002 55.989,125.491 58.78,121.979 51.368,122.246 46.365,118.354 52.904,101.68 58.415,97.061 64.994,97.434 72.054,100.923 67.728,122.722 61.223,124.891 61.383,129.042"
            />

            {/* Podkarpackie */}
            <polygon
                className={`regions ${VoivodeshipType.PODKARPACKIE}`}
                points="128.157,144.037 120.357,145.174 115.287,119.664 126.04,106.631 130.605,108.228 134.544,117.788 148.604,120.532 152.183,117.307 155.241,118.247 141.775,139.181 143.547,151.813"
            />

            {/* Podlaskie */}
            <polygon
                className={`regions ${VoivodeshipType.PODLASKIE}`}
                points="139.029,64.691 122.779,48.021 119.094,37.26 136.861,28.481 133.771,17.034 137.167,11.666 145.408,14.866 155.977,42.361 155.632,55.267 145.675,66.311 147.087,67.797 144.25,68.28"
            />

            {/* Pomorskie */}
            <polygon
                className={`regions ${VoivodeshipType.POMORSKIE}`}
                points="46.061,32.602 45.234,9.291 44.141,7.614 66.737,1.519 74.984,7.284 74.571,7.955 68.801,4.656 74.449,15.131 81.96,13.069 87.224,27.566 81.442,36 65.858,29.981 52.544,36.844"
            />

            {/* Slaskie */}
            <polygon
                className={`regions ${VoivodeshipType.SLASKIE}`}
                points="70.674,131.147 61.888,129.175 61.736,125.246 68.162,123.104 72.542,101.031 79.826,100.952 91.938,106.435 94.685,115.295 84.762,119.481 78.601,129.861 83.563,140.275 78.296,144.135"
            />

            {/* Swietokrzyskie */}
            <polygon
                className={`regions ${VoivodeshipType.SWIETOKRZYSKIE}`}
                points="100.771,117.154 95.191,115.242 92.419,106.296 101.192,93.785 125.708,101.922 125.708,106.247 114.877,119.375 103.623,122.289"
            />

            {/* Warminskomazurskie */}
            <polygon
                className={`regions ${VoivodeshipType.WARMINSKOMAZURSKIE}`}
                points="88.965,41.793 83.542,40.808 81.817,36.337 87.782,27.638 82.43,12.898 86.892,10.862 136.616,11.601 133.232,16.952 136.271,28.214 101.731,45.28 92.748,46.399"
            />

            {/* Wielkopolskie */}
            <polygon
                className={`regions ${VoivodeshipType.WIELKOPOLSKIE}`}
                points="58.499,96.564 54.17,86.409 46.44,88.004 36.935,82.288 38.402,80.685 27.766,73.313 30.994,46.76 32.762,48.824 40.913,43.015 37.864,36.835 45.796,33.027 52.283,37.271 52.313,38.218 53.854,51.996 56.822,58.468 78.45,65.98 77.972,70.715 64.858,96.925"
            />

            {/* Zachodniopomorskie */}
            <polygon
                className={`regions ${VoivodeshipType.ZACHODNIOPOMORSKIE}`}
                points="2.206,53.009 1.497,48.913 4.63,46.108 3.722,23.895 33.517,15.723 40.39,8.355 43.625,7.739 44.739,9.447 45.56,32.585 37.192,36.603 40.276,42.854 32.844,48.151 30.87,45.847 8.065,58.866"
            />

            {props.regions && <MapOfPolandMarkers regions={props.regions} />}
        </svg>
    );
};

const mapContour = (theme: Theme) => css`
    fill: #fff;
    stroke: ${theme.colors.secondary};
    stroke-width: 1.5px;
`;

const mapOfPoland = (theme: Theme) => css`
    .regions {
        fill: #fff;
        stroke: ${theme.colors.secondary};
        stroke-width: 1px;
    }

    &.dolnoslaskie {
        .regions.dolnoslaskie {
            fill: ${theme.colors.gray["200"]};
        }
    }

    &.kujawsko-pomorskie {
        .regions.kujawsko-pomorskie {
            fill: ${theme.colors.gray["200"]};
        }
    }

    &.lodzkie {
        .regions.lodzkie {
            fill: ${theme.colors.gray["200"]};
        }
    }

    &.lubelskie {
        .regions.lubelskie {
            fill: ${theme.colors.gray["200"]};
        }
    }

    &.lubuskie {
        .regions.lubuskie {
            fill: ${theme.colors.gray["200"]};
        }
    }

    &.malopolskie {
        .regions.malopolskie {
            fill: ${theme.colors.gray["200"]};
        }
    }

    &.mazowieckie {
        .regions.mazowieckie {
            fill: ${theme.colors.gray["200"]};
        }
    }

    &.opolskie {
        .regions.opolskie {
            fill: ${theme.colors.gray["200"]};
        }
    }

    &.podkarpackie {
        .regions.podkarpackie {
            fill: ${theme.colors.gray["200"]};
        }
    }

    &.podlaskie {
        .regions.podlaskie {
            fill: ${theme.colors.gray["200"]};
        }
    }

    &.pomorskie {
        .regions.pomorskie {
            fill: ${theme.colors.gray["200"]};
        }
    }

    &.slaskie {
        .regions.slaskie {
            fill: ${theme.colors.gray["200"]};
        }
    }

    &.swietokrzyskie {
        .regions.swietokrzyskie {
            fill: ${theme.colors.gray["200"]};
        }
    }

    &.warminsko-mazurskie {
        .regions.warminsko-mazurskie {
            fill: ${theme.colors.gray["200"]};
        }
    }

    &.wielkopolskie {
        .regions.wielkopolskie {
            fill: ${theme.colors.gray["200"]};
        }
    }

    &.zachodniopomorskie {
        .regions.zachodniopomorskie {
            fill: ${theme.colors.gray["200"]};
        }
    }
`;
